<template>
  <transition name="normal" appear>
    <article class="Cookies" v-if="isVisible">
      <div class="Cookies_text">
        <img src="../../../public/static/images/cookies.svg" />
        <p class="Cookies_title">Un petit cookie ?</p>
        <p class="Cookies_content">Nous utilisons des cookies pour améliorer l’expérience sur le site.</p>
      </div>

      <button class="Cta Cta_line" @click="validateCookies">Avec plaisir <i class="far fa-angle-right"></i></button>
    </article>
  </transition>
</template>

<script>
  import VueCookies from 'vue-cookies'

  export default {
    name: "Cookies",
    data() {
      return {
        isVisible: false
      }
    },
    methods: {
      validateCookies()
      {
        VueCookies.set("tartaucitron", true, "3y")
        this.isVisible = false
      }
    },
    mounted()
    {
      if(VueCookies.isKey("tartaucitron"))
      {
        this.isVisible = false
      }
      else{
        this.isVisible = true
      }
    }
  }
</script>

<style lang="stylus" scoped>
.Cookies

  position fixed
  z-index 1000000
  bottom 10px
  right 15px
  background-color white
  box-shadow 0 3px 20px 0 rgba(0, 0, 0, 0.26)
  border-radius 5px
  padding 43px 43px 43px 95px
  box-sizing border-box
  width 677px
  max-width 100%
  padding-left 160px
  display flex
  flex-direction row
  align-items flex-start
  justify-content space-between
  transition-delay 0.3s!important

  @media $small

    width calc(100% - 25px - 25px)
    right 25px
    bottom 25px
    flex-direction column
    padding-left 95px

  img

    position absolute
    top 50%
    left 43px
    height 100px
    width 100px
    transform translateY(-50%)

    @media $small

      width 55px
      height 55px
      top 43px
      left 25px
      transform none

  &_title

    font-size 24px
    color $blue
    margin-bottom 20px

    @media $small

      font-size 18px

  &_content

    color #1A1A1A
    font-size 16px
    line-height 27px
    font-weight 300
    margin 0px

    @media $small

      font-size: 14px;

  &_text

    width 215px

    @media $small

      width auto
      margin-bottom 25px

</style>